<template>
  <v-card
    v-if="cardData"
    max-width="40rem"
    max-height="30rem"
    class="v-application overflow-auto"
  >
    <EpiSuiteCard
      :item="cardData"
      :elevation="0"
    />
  </v-card>

  <v-card
    v-else-if="isErrorReturned"
    class="p-2"
  >
    {{ tooltipErrorDisplayValue }}
  </v-card>

  <v-card
    v-else
    class="p-2"
  >
    {{ params?.column?.colDef?.headerTooltip }}
  </v-card>
</template>

<script>
import EpiSuiteCard from './EpiSuiteCard/EpiSuiteCard.vue'
import { getEpiSuiteCardMapper } from '@/components/combined-predict/models/epiSuite/epiSuiteCardMappers'
import { ERROR_DISPLAY_VALUE, tooltipErrorDisplayValue } from '@/components/shared-table/buildColumnDef'

export default {
  name: 'EpiSuiteCardTooltip',

  components: {
    EpiSuiteCard,
  },

  data() {
    return {
      chemical: null,
      modelPrediction: null,
      predictionRoot: [],
      property: null,
      location: null,
      tooltipErrorDisplayValue,
    }
  },

  computed: {
    cardData() {
      return this.predictionRoot?.length ? getEpiSuiteCardMapper(this.property)?.(this.predictionRoot) || null : null
    },

    isErrorReturned() {
      return this.formattedData === ERROR_DISPLAY_VALUE
    },

    // isDescriptionDifferent() {
    //   return (this.description && this.nameToShow !== this.description) || !!this.parentDescription
    // },

    // unit() {
    //   return this.params?.unit
    // },
  },

  beforeMount() {
    this.chemical = this.params?.data?.chemical
    this.property = this.params?.property
    this.formattedData = this.params?.valueFormatted
    this.predictionRoot = this.params?.predictionRoot || []
    // this.unit = this.params?.unit
  },
}
</script>
